import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import {
  START_DATE,
} from '../data'

import {
  calculateDateGap,
  padNumber,
} from '../utils'

const useStyles = makeStyles(theme => {
  return {
    root: {
      height: '100%'
    },
    appbar: {
      flexGrow: 1,
      flex: 1,
      width: '100%',
      position: 'fixed',
      zIndex: 1000,
    },
    toolbarContainer: {
      paddingLeft: '0px',
      paddingRight: '0px',
      height: '200px',
      width: '100% !important',
      maxWidth: '100% !important',
    },
    toolbarContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      width: '100% !important',
      maxWidth: '100% !important',
    },
    content: {
      paddingTop: '200px',
      //height: 'calc(100% - 200px)'
    },
    title: {
      
    },
    logo: {
      width: '200px',
      marginRight: theme.spacing(2),
    },
    userName: {
      color: theme.palette.grey[500],
      marginRight: theme.spacing(1),
    },
    toolbarSubtitle: {
      marginBottom: theme.spacing(2),
    },
    toolbarTitle: {
      fontSize: '35px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
        '& span': {
          display: 'block',
          textAlign: 'center',
        },
      },
      '& .years': {

      },
      '& .months': {
        fontSize: '0.9em',
        opacity: 0.9,
      },
      '& .days': {
        fontSize: '0.8em',
        opacity: 0.8,
      },
      '& .hours': {
        fontSize: '0.7em',
        opacity: 0.7,
      },
      '& .minutes': {
        fontSize: '0.6em',
        opacity: 0.6,
      },
      '& .seconds': {
        fontSize: '0.5em',
        opacity: 0.5,
      },
    }
  }
})

const Layout = ({
  children,
}) => {
  const classes = useStyles()
 
  const [ gapData, setGapData ] = useState(null)

  useEffect(() => {
    const calculateDate = () => {
      // const gap = calculateDateGap(START_DATE)
      // const title = `${gap.years} Years, ${padNumber(gap.months)} Months, ${padNumber(gap.days)} Days, ${padNumber(gap.hours)} Hours, ${padNumber(gap.minutes)} Minutes, ${padNumber(gap.seconds)} Seconds`
      setGapData(calculateDateGap(START_DATE))
    }
    calculateDate()
    const intervalId = setInterval(calculateDate, 1000)
    return () => clearInterval(intervalId)
  }, [])

  return (
    <div className={ classes.root }>
      <div className={ classes.appbar }>
        <AppBar position="static">
          <Toolbar className={ classes.toolbarContainer }>
            <div className={ classes.toolbarContent }>
              <Typography 
                variant="body1" 
                color="inherit"
                className={ classes.toolbarSubtitle }
              >
                Time since Kai and Ellie met:
              </Typography>
              {
                gapData && (
                  <div
                    className={ classes.toolbarTitle }
                  >
                    <span className="years">{ gapData.years } Years, </span>
                    <span className="months">{ gapData.months } months, </span>
                    <span className="days">{ gapData.days } days, </span>
                    <span className="hours">{ gapData.hours } hours, </span>
                    <span className="minutes">{ gapData.minutes } minutes, </span>
                    <span className="seconds">{ gapData.seconds } seconds</span>
                  </div>
                )
              }
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <div className={ classes.content }>
        { children }
      </div>
    </div>
  )
}

export default Layout